import styled from 'styled-components'
import WithDirection from '../../../config/withDirection'

const InquiryItemsWrapper = styled.div`
  margin-top: 20px;
  .items-toolbar {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 12px;
    padding: 8px 12px;
    background: ${(props) => props.theme.tokens.surfaceHover};
    border-radius: 6px;
    margin-bottom: 12px;
  }

  .items-toolbar-left {
    flex-shrink: 0;
  }

  .add-buttons-mobile {
    display: none;
  }

  @media (max-width: 575px) {
    .add-buttons-desktop {
      display: none;
    }
    .add-buttons-mobile {
      display: block;
    }
  }

  .items-toolbar-right {
    margin-left: auto;
  }

  @media (max-width: 575px) {
    .items-toolbar-right {
      margin-left: 0;
      width: 100%;
    }
  }

  .doc-container {
    display:-webkit-flex;
    display:flex;
    flex-wrap: wrap;
    list-style-type:none;
    padding:0;
    justify-content:flex-end;
  }

  .left { margin-right: auto; }

  .edit-icon { margin-left: 10px;}

  .title { font-weight: bold;}

  .btn-edit {
    width: 60px;
    margin-right: 10px;
  }
  
  .calculation-button-section {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    padding-bottom: 4px;
  }

  @media (max-width: 575px) {
    .calculation-button-section {
      justify-content: flex-start;
    }

    .doc-container {
      justify-content: flex-start;
    }

    .doc-container > li {
      margin-bottom: 8px;
    }

    .line-items-btn {
      justify-content: flex-start;
    }
  }
  
  .space-between-button {
    margin-right: 10px
  }
  
  .small-between-button {
    margin-left: 3px
  }

  .btn-center {
    text-align: center
  }

  .card-margin {
    margin: 0 0 12px 0;
  }

  .line-items-btn {
    margin-bottom: 10px;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;

    .icon-add-item {
      margin: 0 10px 10px 0;
      display: inline-block;
    }

    .icon-clear-line-item {
      display: inline-block;
    }

    .select-file-line-item-btn {
      margin-right: 10px;

      span {
        display: flex;
        flex-direction: row-reverse;
      }
    }

    .upload-submit-btn {
      margin-right: 10px;
    }
  }
`

export default WithDirection(InquiryItemsWrapper)
